$(window).on('load', function () {
    $(".loading").delay(1000).fadeOut();
    // $("#desktop-video").attr("src", "https://player.vimeo.com/external/558441541.sd.mp4?s=9b9be2b053a95215f1954e6312de87bbdc91610e&profile_id=164");
});

$(document).ready(function () {



    // ------------------------scroll-down js starts------------------------
    $('.scroll-down[data-target]').on('click', function (event) {

        var target = $(this.getAttribute('data-target'));
        if (target.length) {
            event.preventDefault();
            $('html, body').stop().animate({
                scrollTop: target.offset().top
            }, 1000);
        }

    });
    // ------------------------scroll-down js ends--------------------------

    // ------------------------banner video--------------------------

    $(".popup-video").prop('muted', true);
    $(".popup-video").prop('autoplay', true);

    var videoModelLink = $("#video-model-link").text();

    $(".video-play-btn").click(function (e) {
        e.preventDefault();
        $(".banner").addClass("video-playing");
        $(".navbar").addClass("video-playing");
        $(".discover-more").addClass("video-playing");
        $(".video_popup_div").addClass("popup-video_on");
        $(".cursor-video span").text("Pause");

        $(".popup-video").prop('muted', false);
        $(".popup-video").prop('autoplay', true);
        $(".audio_btn").addClass("audio_btn_on");
        $(".audio_btn").addClass("audio__muted");

        $(".fixed-chat-icon").hide();

        $(".popup-video").attr("src", videoModelLink);

        $("html").addClass("no_scroll");

        var myTarget = $(".home-body");
        $('html, body').stop().animate({
            scrollTop: myTarget.offset().top
        }, 500);

    });
    $(".video-stop-cursor").click(function (e) {
        e.preventDefault();
        $(".banner").removeClass("video-playing");
        $(".navbar").removeClass("video-playing");
        $(".discover-more").removeClass("video-playing");
        $(".video_popup_div").removeClass("popup-video_on");
        $(".cursor-video span").text("Play");

        $(".popup-video").prop('muted', true);
        $(".popup-video").prop('autoplay', false);
        $(".audio_btn").removeClass("audio_btn_on");
        $(".audio_btn").removeClass("audio__muted");

        $(".fixed-chat-icon").show();

        $("html").removeClass("no_scroll");

    });


    $(".audio_btn").click(function () {
        if ($(".popup-video").prop('muted')) {
            $(".popup-video").prop('muted', false);
            $(this).addClass("audio__muted");
        } else {
            $(".popup-video").prop('muted', true);
            $(this).removeClass("audio__muted");
        }
    });

    // ------------------------banner video--------------------------



    // filtering --------------------------

    $(".filtering .filter-list .filter-list-items span").click(function (e) {
        e.preventDefault();
        $(this).parent(".filter-list-items").toggleClass("has-subnav");
        $(this).parent(".filter-list-items").siblings().removeClass("has-subnav");
    });

    // filtering --------------------------



    /* Scroll active tab item to view*/
    if ($(window).width() < 992) {
        function centerItVariableWidth(target, outer) {
            var out = $(outer);
            var tar = $(target);
            var x = out.width();
            var y = tar.outerWidth(true);
            var z = tar.index();
            var q = 0;
            var m = out.find('li');

            //Just need to add up the width of all the elements before our target.
            for (var i = 0; i < z; i++) {
                q += $(m[i]).outerWidth(true);
            }
            out.scrollLeft(Math.max(0, q - (x - y) / 2));
        }
        centerItVariableWidth('.side-nav .side_navigation_bar .active', '.side-nav .side_navigation_bar');
        /* Scroll active tab item to view ends*/
    }

    if ($(window).width() < 992) {
        $(".__share__icon__container").click(function (e) {
            e.preventDefault();
            $(".addtoany_share_save_container").toggleClass("addtoany_share_save_container__active");
        });
    }

});

